<button mat-icon-button class="filled" color="warn" (click)="remove()">
  <mat-icon>delete</mat-icon>
</button>
